@if (toast.showsToast$ | async) {
	<div
		class="toast align-items-center text-white"
		[class]="toast.toastState$ | async"
		role="alert"
		aria-live="assertive"
		aria-atomic="true"
	>
		<div class="d-flex">
			<div class="toast-body">{{ toast.toastMessage$ | async }}</div>
			<button
				type="button"
				class="btn-close btn-close-white me-2 m-auto"
				data-bs-dismiss="toast"
				aria-label="Close"
				(click)="dismiss()"
			></button>
		</div>
	</div>
}
